import { SideBarContentHeader } from "@/common/ui/SideBar";
import { SecurityWithModal } from "@/components/dashboard/setting/security/Security";
import React from "react";

const SecurityPage: React.FC = () => {
  return (
    <div className="px-4">
      <SideBarContentHeader heading="Security" />
      <SecurityWithModal />
    </div>
  );
};

export default SecurityPage;
